const getters = {
  isAuthenticated: state => !!state.token
};
export default getters;
